import { Injectable } from '@angular/core';
import { AppState } from 'src/app/app.reducer';
import { EagerSelectEffects } from '../../select/eager-select/eager-select-effects';
import { deviceTypeOptionActions } from './device-type-option.actions';
import { deviceTypeOptionSelectors } from './device-type-option.reducer';

@Injectable({ providedIn: 'root' })
export class DeviceTypeOptionEffects {
   defaultFields: string[] = ['name', 'deviceTypeId'];

   defaultOrderingOptions: string[] = ['name:asc'];

   staticFilters: string[] = [];

   load = this.eagerSelectEffects.createEagerSelectorLoadEffect(
      deviceTypeOptionSelectors.selectState,
      'devicetypes',
      this.defaultFields,
      this.defaultOrderingOptions,
      deviceTypeOptionActions,
      this.staticFilters
   );

   constructor(private eagerSelectEffects: EagerSelectEffects<AppState>) {}
}
